
import makerjs from "makerjs";
function A09(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W = Param[0].param,H = Param[1].param, W1 = Param[2].param,H1 = Param[3].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       h = H * 1 * myZoom,
       w1 = W1 * 1 * myZoom,
       h1 = H1 * 1 * myZoom,
       w = W * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       x0 = 0, x1 = 0, x2 = w, x3 = w1, y0 = 0, y1 = h1, y2 = h, y3 = 0,glassH = h, glassW = w;

   if (h !== 0) {
       var TxtH = H;
   } if (w1 !== 0) {
    var TxtW1 = W1;
} if (h1 !== 0) {
  var TxtH1 = H1;
}
   if (w !== 0) {
       var TxtW = W;
   }



   var drawAbnormalShapeA09 = {
       paths: {
           "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
           "TopLine": new makerjs.paths.Line([x1, y1], [x2, y2]),
           "RightLine": new makerjs.paths.Line([x2, y2], [x3, y3]),
           "BottomLine": new makerjs.paths.Line([x3, y3], [x0, y0]),
       }
   };
   var drawAbnormalShapeA09MarkH1 = {
       paths: {
           "RightLine": new makerjs.paths.Line([x0-markShift, y0], [x0-markShift, y1]),
           "RightShortUpline": new makerjs.paths.Line([x1-markShiftThree, y1], [x1, y1]),
           "RightShortDnline": new makerjs.paths.Line([x0-markShiftThree, y0], [x0, y0]),
       }
   };
   var drawAbnormalShapeA09MarkW1 = {
       paths: {
           "LeftLine": new makerjs.paths.Line([x0, y0-markShift], [x3, y3-markShift]),
           "LeftShortline": new makerjs.paths.Line([x0, y0], [x0, y0-markShiftTwo]),
           "RightShortline": new makerjs.paths.Line([x3, y3], [x3, y3-markShiftTwo]),
       }
   };
   var drawAbnormalShapeA09MarkH = {
       paths: {
            "LeftLine": new makerjs.paths.Line([x2, y2], [x2, y3]),
           "LeftShortline": new makerjs.paths.Line([x2, y2], [x2+markShiftTwo, y2]),
           "RightShortline": new makerjs.paths.Line([x2-markShift, y3], [x2+markShift, y3]),
       }
   };
   var drawAbnormalShapeA09MarkW = {
       paths: {
           "BottomLine": new makerjs.paths.Line([x1, y2], [x2, y2]),
           "BotmShortLfline": new makerjs.paths.Line([x1, y2-markShift], [x1, y2 + markShift]),
           "BotmShortRTline": new makerjs.paths.Line([x2, y2-markShift], [x2, y2 + markShift]),
       }
  //  };
  
   };
   makerjs.model.addCaption(drawAbnormalShapeA09MarkW1, TxtW1, [x0, y0 - 2 * markShift], [x3, y3 - 2 * markShift]);//长度文字  
   makerjs.model.addCaption(drawAbnormalShapeA09MarkH1, TxtH1, [x0-markShiftTwo, y0], [x0-markShiftTwo, y1]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeA09MarkH, TxtH, [x2+markShift, y2], [x2+markShift, y3]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeA09MarkW, TxtW, [x1, y2+ markShift], [x2, y2+ markShift]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeA09: drawAbnormalShapeA09,
      }
    };
    markers={
      models: {
        drawAbnormalShapeA09: drawAbnormalShapeA09,
        drawAbnormalShapeA09MarkW1: drawAbnormalShapeA09MarkW1,
        drawAbnormalShapeA09MarkH1: drawAbnormalShapeA09MarkH1,
        drawAbnormalShapeA09MarkH:drawAbnormalShapeA09MarkH,
        drawAbnormalShapeA09MarkW:drawAbnormalShapeA09MarkW
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default A09;